<script setup lang="ts"></script>

<template>
  <div class="flex-1 flex items-center justify-center text-center text-neutral-500 p-10">
    <div class="max-w-[560px]">
      <h2 class="text-xl text-neutral-700 font-semibold mb-2">FORESIGHT Reports : Smart Assist</h2>
      <h3 class="text-sm text-neutral-400 mb-6">
        Ask about protests, campaigns, activist groups, companies, sectors, or regions.
      </h3>
    </div>
  </div>
</template>
